import { ReactElement } from "react";
import QualityControlForm from "./QualityControlForm";
import FilterCellsGenesForm from "./FilterCellsGenesForm";
import DoubletDetectionForm from "./DoubletDetectionForm";
import NormalizationForm from "./NormalizationForm";
import FeatureSelectionForm from "./FeatureSelectionForm";
import DimensionalityReductionForm from "./DimensionalityReductionForm";
import UMAPForm from "./UMAPForm";
import ClusteringForm from "./ClusteringForm";
import CellTypeAnnotationForm from "./CellTypeAnnotationForm";
import MarkerGeneSetForm from "./MarkerGeneSetForm";
import DEGenesMarkersForm from "./DEGenesMarkersForm";
import EnrichmentForm from "./EnrichmentForm";
import TrajectoryAnalysisForm from "./TrajectoryAnalysisForm";

export interface DynamicFormRendererProps {
  currentStep: string;
  dataType: string;
  onSubmit?: (data: any) => void;
  onBack?: () => void;
  onContinue?: () => void;
  className?: string;
  projectContext?: string;
  annotationResult?: any;
}

const DynamicFormRenderer = ({
  currentStep,
  dataType,
  onSubmit,
  onBack,
  onContinue,
  className = "",
  projectContext = "",
  annotationResult,
}: DynamicFormRendererProps): ReactElement => {
  // Early return if required data is missing
  if (!currentStep || !dataType) {
    return <p>No form available.</p>;
  }

  const step = currentStep.toLowerCase().trim();
  const type = dataType.toLowerCase().trim();

  if (type === "single cell data") {
    switch (step) {
      case "fullpipeline":
        return (
          <div
            style={{ marginTop: "1rem", padding: "2rem", textAlign: "center" }}
          >
            <p>Unified Single Cell form coming soon...</p>
          </div>
        );

      case "quality-control":
        return (
          <QualityControlForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "filter-cells-genes":
        return (
          <FilterCellsGenesForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "doublet-detection":
        return (
          <DoubletDetectionForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "normalization":
        return (
          <NormalizationForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "feature-selection":
        return (
          <FeatureSelectionForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "dimensionality-reduction":
        return (
          <DimensionalityReductionForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "umap":
        return (
          <UMAPForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "clustering":
        return (
          <ClusteringForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "cell-type-annotation":
        return (
          <CellTypeAnnotationForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "marker-gene-set":
        return (
          <MarkerGeneSetForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
            projectContext={projectContext}
            annotationResult={annotationResult}
          />
        );

      case "de-genes-markers":
        return (
          <DEGenesMarkersForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "enrichment":
        return (
          <EnrichmentForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      case "trajectory-analysis":
        return (
          <TrajectoryAnalysisForm
            onSubmit={onSubmit}
            onBack={onBack}
            onContinue={onContinue}
          />
        );

      default:
        return <p>No form available for this step.</p>;
    }
  }

  return <p>No form available for this data type.</p>;
};

export default DynamicFormRenderer;
